import { createContext, PropsWithChildren, useContext } from 'react';

import { trpc, TrpcOutputs } from '../config/trpc';
import { useCurrentRequest } from '../hooks/useCurrentRequest';

export const ShipmentContext = createContext<{
  request: TrpcOutputs['getTrackingShipmentInfo'];
  refetchRequest: () => Promise<any>;
  subscribers: TrpcOutputs['getShipmentSubscribers'];
  refetchSubscribers: () => Promise<any>;
}>(undefined);

export const useTrackingInfo = () => {
  return useContext(ShipmentContext);
};

export const ShipmentContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const { request } = useCurrentRequest();

  const { data: shipmentInfo, refetch: refetchRequest } = trpc.getTrackingShipmentInfo.useQuery({
    request_id: request?.id,
  });

  const { data: subscribers, refetch: refetchSubscribers } = trpc.getShipmentSubscribers.useQuery({
    request_id: request?.id,
  });

  return (
    <ShipmentContext.Provider
      value={{
        refetchRequest,
        refetchSubscribers,
        request: shipmentInfo,
        subscribers,
      }}
    >
      {children}
    </ShipmentContext.Provider>
  );
};
